import {
  AddressForm,
  AddressTypeCode,
  SaveAddressesResponse,
  SaveAddressResponse,
} from '../../../global-types/addresses';
import { saveAddress, saveAddresses } from '../../../services/address';
import { formatAddress } from './format-address';

// handles the address submission for 1:M cards,
// when addresses are selected from the address book
// and the user is submitting the address form
export const handleAddressSubmitOneToMany = async (
  project_id: string | undefined,
  payload: AddressForm | AddressForm[],
  addressVerificationEnhancedMatch: boolean,
  addressType?: AddressTypeCode,
): Promise<SaveAddressesResponse | SaveAddressResponse> => {
  if (!project_id) return Promise.reject(new Error('Project id is required'));

  if (Array.isArray(payload)) {
    const formattedAddresses = payload.map((data) => {
      const address = formatAddress(data);

      return {
        address,
        is_verified: data.skip_usps_validation,
      };
    });

    return saveAddresses(project_id, { addresses: formattedAddresses });
  }

  return saveAddress(
    project_id,
    {
      ...formatAddress(payload),
      skip_usps_validation: !!payload.skip_usps_validation,
      address_type_code: addressType || AddressTypeCode.RECIPIENT,
    },
    addressVerificationEnhancedMatch,
  );
};
